/* src/app/components/doc-viewer-new/doc-viewer-right-panel/doc-viewer-right-panel.component.scss */
.right-panel-container {
  background: #fff;
}
:host-context(.dark-theme) .right-panel-container {
  background: #2e2e2e;
}
.tabs {
  background: #f5f5f5;
  color: #000;
}
.selected {
  background: #fff;
  color: #000;
}
.selected-icon {
  --fa-primary-color: rgba(36, 62, 144, 0.5);
  --fa-secondary-color: rgb(36, 62, 144);
  --fa-secondary-opacity: 1 ;
}
.settings-icon {
  --fa-primary-color: rgb(36, 62, 144);
  --fa-secondary-color: rgb(36, 62, 144);
  --fa-primary-opacity: 0.4;
  --fa-secondary-opacity: 1;
}
.icon {
  --fa-primary-color: rgb(36, 62, 144);
  --fa-secondary-color: rgb(36, 62, 144);
  --fa-secondary-opacity: 0.4;
}
:host-context(.dark-theme) .tabs {
  background: #101010;
  color: #FFF;
  border-bottom: none;
}
:host-context(.dark-theme) .selected {
  background: #2E2E2E;
  color: #FFF;
}
:host-context(.dark-theme) .icon {
  --fa-primary-color: #E2E2E2;
  --fa-secondary-color: #6c6c6c;
  --fa-secondary-opacity: 1;
}
:host-context(.dark-theme) .selected-icon {
  --fa-primary-color: #FFC107;
  --fa-secondary-color: #8d8d8d;
  --fa-secondary-opacity: 1;
}
:host-context(.dark-theme) .settings-icon {
  --fa-primary-color: #8d8d8d;
  --fa-secondary-color: #FFC107;
  --fa-primary-opacity: 1;
  --fa-secondary-opacity: 1;
}
/*# sourceMappingURL=doc-viewer-right-panel.component.css.map */
